module.exports = __webpack_public_path__ + "img/oufu_70x88x12b.prt.2620cb7f.jpg";